import type { DashboardUsage, SubscriptionPlan } from 'src/types/common';

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface GeneralState {
    environment: 'sandbox' | 'production';
    subscriptionPlans: SubscriptionPlan[];
    dashboardUsage: DashboardUsage | null;
}

const initialGeneralState = {
  environment: 'sandbox' as 'sandbox' | 'production',
  subscriptionPlans: [],
  dashboardUsage: null,
} as GeneralState;

type Actions = {
  reset: () => void;
};

export const generalModel = create(
  persist<GeneralState & Actions>(
    (set) => ({
      ...initialGeneralState,
      reset: () => {
        set(initialGeneralState);
      },
    }),
    {
      name: 'sc-general-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
